import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-4 text-warm-brown/80 leading-relaxed" data-id="element-52">
    <h3 className="font-serif text-2xl font-bold text-warm-brown" data-id="element-53">
      Política de Privacidad
    </h3>
    <p data-id="element-54">
      <strong data-id="element-55">Última actualización:</strong> Marzo 2026
    </p>
    <p data-id="element-56">
      Tu privacidad es importante para nosotros. Esta Política de Privacidad
      describe cómo recopilamos, usamos y protegemos tu información personal
      cuando utilizas nuestro sitio web y adquieres nuestros productos
      digitales.
    </p>
    <h4 className="font-serif text-lg font-semibold text-warm-brown" data-id="element-57">
      1. Información que recopilamos
    </h4>
    <p data-id="element-58">
      Recopilamos únicamente la información necesaria para procesar tu compra,
      incluyendo tu nombre, dirección de correo electrónico y datos de pago. No
      almacenamos información de tarjetas de crédito en nuestros servidores.
    </p>
    <h4 className="font-serif text-lg font-semibold text-warm-brown" data-id="element-59">
      2. Uso de la información
    </h4>
    <p data-id="element-60">
      Utilizamos tu información para: entregar los productos digitales
      adquiridos, enviar actualizaciones relacionadas con tu compra y mejorar
      nuestros servicios. No vendemos ni compartimos tu información personal con
      terceros con fines de marketing.
    </p>
    <h4 className="font-serif text-lg font-semibold text-warm-brown" data-id="element-61">
      3. Protección de datos
    </h4>
    <p data-id="element-62">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      tu información personal contra acceso no autorizado, pérdida o alteración.
    </p>
    <h4 className="font-serif text-lg font-semibold text-warm-brown" data-id="element-63">
      4. Cookies
    </h4>
    <p data-id="element-64">
      Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
      navegación. Puedes configurar tu navegador para rechazar cookies, aunque
      esto podría afectar algunas funcionalidades del sitio.
    </p>
    <h4 className="font-serif text-lg font-semibold text-warm-brown" data-id="element-65">
      5. Tus derechos
    </h4>
    <p data-id="element-66">
      Tienes derecho a acceder, rectificar o eliminar tu información personal en
      cualquier momento. Para ejercer estos derechos, puedes contactarnos a
      través de los canales disponibles en nuestro sitio.
    </p>
  </div>;
const termsContent = <div className="space-y-4 text-warm-brown/80 leading-relaxed" data-id="element-67">
    <h3 className="font-serif text-2xl font-bold text-warm-brown" data-id="element-68">
      Términos y Condiciones
    </h3>
    <p data-id="element-69">
      <strong data-id="element-70">Última actualización:</strong> Marzo 2026
    </p>
    <p data-id="element-71">
      Al acceder a este sitio web y/o adquirir nuestros productos digitales,
      aceptas cumplir con los siguientes términos y condiciones.
    </p>
    <h4 className="font-serif text-lg font-semibold text-warm-brown" data-id="element-72">
      1. Productos digitales
    </h4>
    <p data-id="element-73">
      Los productos ofrecidos son materiales educativos en formato digital
      (eBook, audiolibro y guías). Al completar tu compra, recibirás acceso
      inmediato a los materiales a través del correo electrónico proporcionado.
    </p>
    <h4 className="font-serif text-lg font-semibold text-warm-brown" data-id="element-74">
      2. Uso personal
    </h4>
    <p data-id="element-75">
      Los materiales adquiridos son para uso personal y no pueden ser
      reproducidos, distribuidos, compartidos o revendidos sin autorización
      expresa por escrito.
    </p>
    <h4 className="font-serif text-lg font-semibold text-warm-brown" data-id="element-76">
      3. Aviso de salud
    </h4>
    <p data-id="element-77">
      La información proporcionada en nuestros productos es de carácter
      educativo y no sustituye el consejo médico profesional. Si tu bebé
      presenta problemas de sueño persistentes o condiciones médicas, consulta
      con un pediatra.
    </p>
    <h4 className="font-serif text-lg font-semibold text-warm-brown" data-id="element-78">
      4. Política de reembolso
    </h4>
    <p data-id="element-79">
      Debido a la naturaleza digital de nuestros productos, no ofrecemos
      reembolsos una vez que se ha entregado el acceso al material. Sin embargo,
      nos comprometemos a resolver cualquier problema técnico que impida el
      acceso a tu compra.
    </p>
    <h4 className="font-serif text-lg font-semibold text-warm-brown" data-id="element-80">
      5. Modificaciones
    </h4>
    <p data-id="element-81">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones serán efectivas desde su publicación en este
      sitio web.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-warm-brown py-8 px-6" data-id="element-82">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-83">
          <div className="flex items-center gap-6" data-id="element-84">
            <button onClick={() => setActiveModal('privacy')} className="text-white/70 hover:text-white text-sm transition-colors duration-200 underline underline-offset-2" data-id="element-85">
              Política de Privacidad
            </button>
            <span className="text-white/30" data-id="element-86">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-white/70 hover:text-white text-sm transition-colors duration-200 underline underline-offset-2" data-id="element-87">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-white/50 text-xs" data-id="element-88">
            © {new Date().getFullYear()} Terapia de Sueño 7-Min. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-89">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-90">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-cream rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 md:p-10 relative" onClick={e => e.stopPropagation()} data-id="element-91">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-warm-brown/10 hover:bg-warm-brown/20 transition-colors duration-200" aria-label="Cerrar" data-id="element-92">
                <XIcon className="w-5 h-5 text-warm-brown" data-id="element-93" />
              </button>

              <div className="pr-8" data-id="element-94">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}